import {$http} from "@http";
import md5 from "md5";
import {isEmpty, httpBuildQuery} from "@helpers/helpers";
import {inArray, is_array, ObjectLength} from "@helpers/arrays";
import {getCacheKey} from "./cache_key";

const cacheTable = 'widget';
var oldWidgetPath = '';
var getWidgetRequest = undefined;

/**
 * @param type {string}
 * @param page {string|nullable}
 * @param section {string|nullable}
 * @param city_id {int}
 * @param district_id {[]|nullable}
 * @param item_id {int|nullable}
 * @param properties_types {string|nullable}
 * @param properties_deal_types {string|nullable}
 * @param url {string|nullable}
 * @param count {int|nullable} => default = 1
 * */
function getWidgets({type, page = null, section = null, city_id, district_id = null, item_id = null, properties_types = null, properties_deal_types = null, url = null, count = 1}) {
    let path = '/v1/widgets?';
    const params = {
        type: type,
        page: page,
        section: section,
        city_id: city_id,
        district_id: district_id,
        item_id: item_id,
        properties_types: properties_types,
        properties_deal_types: properties_deal_types,
        url: url,
        count: count
    };

    path += httpBuildQuery(params);

    if (oldWidgetPath === path && !isEmpty(getWidgetRequest)) {
        getWidgetRequest.cancel();
    }

    const cacheKey = getCacheKey(cacheTable, type, 'hash', [md5(path)]);
    const cacheTTL = 24 * 60 * 60; // second

    return new Promise((resolve, reject) => {
        $http(cacheKey, path, cacheTTL).then(result => {
            resolve(result)
        }).catch(err => {
            reject(err)
        })
    })
}

/**
 * @param widget_id {Number}
 *
 * @return Promise
 * */
export function getWidgetById(widget_id) {
    const path = '/v1/widgets/' + widget_id;
    const cacheKey = getCacheKey(cacheTable, 'lists', 'id', [widget_id]);
    const cacheTTL = 24 * 60 * 60;

    return new Promise((resolve, reject) => {
        $http(cacheKey, path, cacheTTL).then(result => {
            resolve(result);
        }).catch(err => {
            reject(err)
        })
    })
}


/**
 * @param widget_id {Number}
 *
 * @return Promise
 * */
export function getWidgetProperties(widget_id) {
    const path = `/v1/widgets/${widget_id}/getProperties`;
    const cacheKey = getCacheKey(cacheTable, 'properties', 'widget-id', [widget_id]);
    const cacheTTL = 24 * 60 * 60;

    return new Promise((resolve, reject) => {
        $http(cacheKey, path, cacheTTL).then(result => {
            resolve(result);
        }).catch(err => {
            reject(err)
        })
    })
}

/**
 * @param widget
 *
 * @return Object
 * */
function getWidgetSearchParams(widget) {
    let {params} = widget;
    params = JSON.parse(params);

    const unsetParam = ['widget_city_id', 'widget_district_id', 'widget_type',
        'page', 'section', 'max_items', 'url', 'position', 'content',
        'files', 'file', 'caption', 'title', 'label', 'city_geo_text', 'city_name',
        'city_type', 'widget_item_id', '_token'
    ];

    for (let item of unsetParam) {
        delete params[item]
    }

    const convertParam = [
        {from: 'type', to: 'types'},
    ];

    for (let convert of convertParam) {
        if (!isEmpty(params[convert.from])) {
            params[convert.to] = params[convert.from];
            delete params[convert.from];
        }
    }

    return params;
}


// ********* Helpers ************

function widgetFilters($widget, filters) {
    const $allSearchParams = JSON.parse(JSON.stringify(filters)); // deep copy
    let showWidget = true;

    if (!isEmpty($widget)) {
        const ignoreSearchParams = [
            'properties',
            'users_ids', 'city_type', 'city_WKT', 'district_WKT', 'city_geo_text', 'district_geo_text', 'district_name', 'district_type', 'widget_item_id', 'city_name', 'province_id', 'customLink', 'search_sort', 'sort', 'page', 'is_canonical', 'q',
            'checkRedirectToLanding', 'breadcrumbList'
        ];

        if (ObjectLength($allSearchParams)) {
            Object.keys($allSearchParams).forEach(key => {
                if (inArray(key, ignoreSearchParams)) {
                    delete $allSearchParams[key];
                }
            });
        }

        let widgetParams = JSON.parse($widget.params);
        const ignoreWidgetParams = ['type', 'properties_types', 'properties_deal_types', 'widget_type', 'page', 'section', 'widget_city_id', 'widget_district_id', 'widget_item_id', 'max_items', 'caption', 'title', 'label', 'url', 'position', 'content', 'files', 'file', 'city_geo_text', 'city_name', 'city_type', '_token', 'district_name', 'district_type', 'district_geo_text'];

        if (!isEmpty(widgetParams['type']) && widgetParams['type'].length) {
            widgetParams['types'] = widgetParams['type'];
        }

        Object.keys(widgetParams).forEach(key => {
            if (inArray(key, ignoreWidgetParams)) {
                delete widgetParams[key];
            }
        });

        if (!isEmpty(widgetParams['deal_type']) && is_array(widgetParams['deal_type']) && widgetParams['deal_type'].length) {
            widgetParams['deal_type'] = widgetParams['deal_type'][0];
        } else {
            delete widgetParams['deal_type'];
        }


        if (!isEmpty(widgetParams) && ObjectLength(widgetParams) === ObjectLength($allSearchParams)) {
            Object.keys($allSearchParams).forEach(key => {
                const searchParam = $allSearchParams[key];
                if (!isEmpty(searchParam)) {
                    if (!isEmpty(widgetParams[key])) {
                        if (is_array(searchParam)) {
                            if (is_array(widgetParams[key])) {
                                Object.keys(searchParam).forEach(paramKey => {
                                    const param = String(searchParam[paramKey]);

                                    if (!isEmpty(param) && param.indexOf('.') !== -1) {
                                        for (let merged of param.split('.')) {
                                            if (!inArray(merged, widgetParams[key])) {
                                                //console.log(1)
                                                showWidget = false;
                                            }
                                        }
                                    } else if (!inArray(param, widgetParams[key])) {
                                        //console.log(1.1)
                                        showWidget = false;
                                    }
                                })
                            } else {
                                //console.log(2)
                                showWidget = false;
                            }
                        } else {
                            if (is_array(widgetParams[key])) {
                                if (!inArray(searchParam, widgetParams[key])) {
                                    //console.log(3)
                                    showWidget = false;
                                }
                            } else if (searchParam != widgetParams[key]) {
                                //console.log(4)
                                showWidget = false;
                            }
                        }
                    } else {
                        showWidget = false;
                        //console.log(5)
                    }
                } else if (!isEmpty(widgetParams[key])) {
                    showWidget = false;
                    //console.log(6)
                }
            });
        }

        if (ObjectLength(widgetParams) !== ObjectLength($allSearchParams)) {
            showWidget = false;
            //console.log(7)
        }

        return showWidget;
    }
}

export {
    getWidgets,
    getWidgetSearchParams,
    widgetFilters
}